import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { EMPTY_ARRAY } from '#pplx/frontend/common/defaults.js';
import { isSourceType } from '#pplx/frontend/components/utils/SourcesConfig.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { autosuggestGeneralClient } from '#pplx_generated/typespec/rest/autosuggest/general/client.js';
export const fetchBlankStateSuggestions = async ({ sources, attachments, searchMode, sourceTabUrl, entropyRenderingPlace, reason, }) => {
    try {
        // The BE returns an empty array if the attachments are present so we can short-circuit here
        if (attachments && attachments.length > 0) {
            return EMPTY_ARRAY;
        }
        // The BE returns an empty array if the sources are empty so we can short-circuit here
        if (sources.length === 0) {
            return EMPTY_ARRAY;
        }
        // guards against the BE pydantic model validation error when non-sourceType sources are sent to the /rest/autosuggest/list-autosuggest endpoint
        const sourceTypeSources = sources.filter(isSourceType);
        if (sourceTypeSources.length !== sources.length) {
            logger.warn('Some sources were filtered out because they were not valid source types', {
                invalidSources: sources.filter((source) => !isSourceType(source)),
            });
        }
        const { data, error, response } = await autosuggestGeneralClient.POST('/rest/autosuggest/list-autosuggest', reason, {
            body: {
                query: '',
                sources: sourceTypeSources,
                attachments,
                search_mode: searchMode,
                source_tab_url: sourceTabUrl,
                entropy_rendering_place: entropyRenderingPlace,
            },
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                cause: error,
                status: response.status ?? 0,
            });
        }
        return (data?.results ?? EMPTY_ARRAY);
    }
    catch (err) {
        logger.error(err);
        return EMPTY_ARRAY;
    }
};
//# sourceMappingURL=fetchBlankStateSuggestions.js.map